import { Assessment } from '@app-types';

type ConflictContext = {
  original_tier_id?: number;
  original_tier_name?: string;
  current_tier_id?: number;
  current_tier_name?: string;
  // Legacy field names (backwards compatibility)
  old_tier_id?: number;
  old_tier_name?: string;
  new_tier_id?: number;
  new_tier_name?: string;
};

type Conflict = {
  id: number;
  conflict_type_code: string;
  status: string;
  context: ConflictContext;
};

/**
 * Check if assessment has open (unresolved) conflicts
 */
export const hasOpenConflicts = (assessment: Assessment): boolean => {
  return (assessment.conflicts || []).some((c) => c.status !== 'resolved');
};

/**
 * Get the first open conflict from assessment
 */
export const getFirstOpenConflict = (assessment: Assessment): Conflict | undefined => {
  return (assessment.conflicts || []).find((c) => c.status !== 'resolved') as Conflict | undefined;
};

/**
 * Generate tooltip message for tier conflict
 * Shows original and current tier names if available
 */
export const getTierConflictTooltip = (assessment: Assessment): string => {
  const conflict = getFirstOpenConflict(assessment);

  if (conflict?.conflict_type_code !== 'ASSESSMENT_TIER_CHANGE') {
    return 'Assessment has conflict';
  }

  const context = conflict.context;

  // Support both new and legacy field names
  const originalTierName = context.original_tier_name || context.old_tier_name;
  const currentTierName = context.current_tier_name || context.new_tier_name;

  if (originalTierName && currentTierName) {
    return `Tier changed: ${originalTierName} → ${currentTierName}`;
  }

  return 'Tier conflict';
};

